import { axiosAuthInstance } from "../config/axios-config";
import { getCommunityId } from "../store/communities.store";

const communityId = getCommunityId()
var ClusterService = {
  getClusters: async function (input) {
    return await axiosAuthInstance
      .get("/clusters", { params: { ...input } })
      .then((res) => {
        return res.data;
      });
  },

  setUpCluster: async function (input, clusterId) {
    // console.log(input);
    return await axiosAuthInstance
      .post(`/clusters/${clusterId}/setup`, input)
      .then((res) => {
        return res.data;
      });
  },
  getClusterInfo: async function (clusterId) {
    return await axiosAuthInstance
      .get(`/clusters/${clusterId ?? communityId}`)
      .then((res) => {
        return res.data;
      });
  },

  getClusterWithEstateId: async function (estateId) {
    return await axiosAuthInstance.get(`/clusters`, { params: { estateId } });
  },

  updateCluster: async function (input, clusterId) {
    return await axiosAuthInstance.put(
      `/clusters/${clusterId ?? communityId}`,
      {
        name: input.estate_name,
        location: {
          address: input.estate_address,
          city: input.city,
          state: input.state,
          country: input.country,
          latitude: input.latitude,
          longitude: input.longitude,
        },
      }
    );
  },

  editCluster: async function (input, clusterId) {
    return await axiosAuthInstance.put(
      `/clusters/${clusterId ?? communityId}`,
      {
        name: input.clusterName,
        location: {
          address: input.address,
          city: input.city,
          state: input.state,
          country: input.country,
          latitude: input.latitude,
          longitude: input.longitude,
        },
      }
    );
  },

  getUpdateRequests: async function (input) {
    return await axiosAuthInstance
      .get(`/update-requests/cluster`, { params: { ...input } })
      .then((res) => {
        return res.data;
      });
  },

  approveUpdateRequest: async function (id) {
    return await axiosAuthInstance
      .post(`update-requests/cluster/${id}/approve`)
      .then((res) => {
        return res.data;
      });
  },

  rejectUpdateRequest: async function (id) {
    return await axiosAuthInstance
      .post(`update-requests/cluster/${id ?? communityId}/deny`)
      .then((res) => {
        return res.data;
      });
  },

  assignUnitToCluster: async function (unitId, clusterId) {
    return await axiosAuthInstance
      .post(`/units/${unitId}/assign/cluster/${clusterId ?? communityId}`)
      .then((res) => {
        return res.data;
      });
  },

  getParentEstateUnitTypes: async function (parentEstateId) {
    return await axiosAuthInstance
      .get(`/unit-types`, {
        params: {
          communityId: parentEstateId
           
      }})
      .then((res) => {
        return res.data;
      });
  },
};

export default ClusterService;
